//公用模板 暂时用于工具下载下的激活客户端、OEM用户下载登录成功显示数据、和OEM搜索结果显示及激活客户端搜索结果显示
<template>
  <div class="public">
    <div class="top_title">
      <span>{{show_title}}</span>
    </div>
    <div class="main">
      <ul class="title">
        <li>名称</li>
        <li class="goOut">详细信息</li>
        <li>SHA256校验码</li>
        <li>版本</li>
        <li>大小</li>
        <li>更新日期</li>
        <li>下载</li>
      </ul>
      <p class="tips" v-if="searchShow">
        搜索结果：
        <span v-if="list.length === 0">--无匹配结果--</span>
        <span class="close" title="关闭" @click="closeSearch()">X</span>
      </p>
      <p class="tips" v-if="$route.params.id === 'oem' && list.length === 0">
        <span v-if="list.length === 0">--无对应数据--</span>
      </p>
      <ul v-for="(item,index) in list">
        <li>
          <p>{{item.name}}</p>
        </li>
        <li>
          <p v-html="item.description"></p>
        </li>
        <li :title="item.md5">{{item.md5}}</li>
        <li>{{item.ver}}</li>
        <li>{{item.size}}</li>
        <li>{{item.update_time}}</li>
        <li>
          <!-- <a href="javascript:void(0)" @click="downLink(index)" v-if="$route.params.id === 'oem'">
                <img :src="downloadIcon" alt="下载">
          </a>-->
          <a :href="item.links" target="_blank">
            <img :src="downloadIcon" alt="下载" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { post, fetch } from "@/util/http";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "public",
  watch: {
    $route(to, from) {
      let self = this;
      self.isShow = -1;
      self.list = [];
      self.searchShow = false;
      if (!sessionStorage.getItem("isLogin") && to.params.id === "oem") {
        console.info('111222333 goto oem login')
        this.$router.push({ name: "login" });
      } else if (sessionStorage.getItem("isLogin") && to.params.id === "oem") {
        self.show_title = "镜像下载";
        post("download/oem/list/", {
            is_is_sn: sessionStorage.getItem('is_sn'),
            device_sn: sessionStorage.getItem('device_sn'),
            sn: sessionStorage.getItem('sn')
          },
          {
            "Content-Type": "application/json", //设置跨域头部
            // Authorization: "JWT " + sessionStorage.getItem("oemToken")
          }
        ).then(
          res => {
            res.forEach(function(item) {
              self.list.push({
                name: item.name,
                id: item.id,
                ver: item.ver,
                update_time: item.update_at.substring(0, 10),
                links: item.links,
                size: (item.size / 1024 / 1024).toFixed(2) + "M",
                description: item.description,
                classify: item.classify,
                md5: item.md5
              });
            });
          },
          err => {
            sessionStorage.removeItem("isLogin");
            sessionStorage.removeItem("oemToken");
            self.$router.push({ name: "login" });
          }
        );
      } else if (to.params.id === "tools") {
        this.getShowTitleFromMenus();
        fetch(
          "download/tool/listByClassify/" + to.params.classify,
          {},
          {
            "Content-Type": "application/json", //设置跨域头部
            // Authorization: "JWT " + sessionStorage.getItem("oemToken")
          }
        ).then(
          res => {
            // res.forEach(function(item) {
            //   self.list.push({
            //     name: item.name,
            //     id: item.id,
            //     ver: item.ver,
            //     update_time: item.update_at.substring(0,10),
            //     links: item.links,
            //     size: (item.size / 1024 / 1024).toFixed(2) + 'M',
            //     description: item.description,
            //     classify: item.classify,
            //     md5: item.md5
            //   });
            // });
            res.forEach(item => {
              if (item.description.indexOf("手机APP") > -1) {
                return;
              } else {
                self.list.push({
                  name: item.name,
                  id: item.id,
                  ver: item.ver,
                  update_time: item.update_at.substring(0, 10),
                  links: item.links,
                  size: (item.size / 1024 / 1024).toFixed(2) + "M",
                  description: item.description,
                  classify: item.classify,
                  md5: item.md5
                });
              }
            });
          },
          err => {
            //工具下载页面请求失败
          }
        );
      } else if (to.params.id === "search") {
        this.show_title = "搜索结果";
        let self = this;
        fetch(
          "download/search/",
          {
            params: {
              dest: to.params.date
            }
          },
          {
            "Content-Type": "application/json", //设置跨域头部
            // Authorization: "JWT " + sessionStorage.getItem("oemToken")
          }
        ).then(
          res => {
            res.forEach(function(item) {
              self.list.push({
                name: item.name,
                id: item.id,
                ver: item.ver,
                update_time: item.update_at.substring(0, 10),
                links: item.links,
                size: (item.size / 1024 / 1024).toFixed(2) + "M",
                description: item.description,
                classify: item.classify,
                md5: item.md5
              });
            });
            self.searchShow = true;
          },
          err => {
            //搜索页面请求失败
          }
        );
      }
    }
  },
  beforeCreate: function() {
    let self = this;
    self.list = [];
    if (!sessionStorage.getItem("isLogin") && this.$route.params.id === "oem") {
      this.$router.push({ name: "login" });
    } else if (
      sessionStorage.getItem("isLogin") &&
      this.$route.params.id === "oem"
    ) {
      self.show_title = "镜像下载";

      post("download/oem/list/", {
          is_sn: sessionStorage.getItem('is_sn'),
          device_sn: sessionStorage.getItem('device_sn'),
          sn: sessionStorage.getItem('sn')
        },
        {
          "Content-Type": "application/json", //设置跨域头部
          // Authorization: "JWT " + sessionStorage.getItem("oemToken")
        }
      ).then(
        res => {
          res.forEach(function(item) {
            if (item.description.indexOf("手机APP") > -1) {
              return;
            } else {
              self.list.push({
                name: item.name,
                id: item.id,
                ver: item.ver,
                update_time: item.update_at.substring(0, 10),
                links: item.links,
                size: (item.size / 1024 / 1024).toFixed(2) + "M",
                description: item.description,
                classify: item.classify,
                md5: item.md5
              });
            }
          });
        },
        err => {
          sessionStorage.removeItem("isLogin");
          sessionStorage.removeItem("oemToken");
          self.$router.push({ name: "login" });
        }
      );
    } else if (this.$route.params.id === "tools") {
      this.show_title = "工具下载";
      fetch(
        "download/tool/listByClassify/" + this.$route.params.classify,
        {},
        {
          "Content-Type": "application/json", //设置跨域头部
          // Authorization: "JWT " + sessionStorage.getItem("oemToken")
        }
      ).then(
        res => {
          // res.forEach(function(item) {
          //   self.list.push({
          //     name: item.name,
          //     id: item.id,
          //     ver: item.ver,
          //     update_time: item.update_at.substring(0,10),
          //     links: item.links,
          //     size: (item.size / 1024 / 1024).toFixed(2) + 'M',
          //     description: item.description,
          //     classify: item.classify,
          //     md5: item.md5
          //   });
          // });
          this.list = [];
          res.forEach(item => {
            if (item.description.indexOf("手机APP") > -1) {
              return;
            } else {
              self.list.push({
                name: item.name,
                id: item.id,
                ver: item.ver,
                update_time: item.update_at.substring(0, 10),
                links: item.links,
                size: (item.size / 1024 / 1024).toFixed(2) + "M",
                description: item.description,
                classify: item.classify,
                md5: item.md5
              });
            }
          });
          // self.list.push({
          //     name: res[0].name,
          //     id: res[0].id,
          //     ver: res[0].ver,
          //     update_time: res[0].update_at.substring(0,10),
          //     links: res[0].links,
          //     size: (res[0].size / 1024 / 1024).toFixed(2) + 'M',
          //     description: res[0].description,
          //     classify: res[0].classify,
          //     md5: res[0].md5
          //   });
        },
        err => {
          //工具下载页面请求失败
        }
      );
    } else if (this.$route.params.id === "search") {
      this.show_title = "搜索结果";
      let self = this;
      fetch(
        "download/search/",
        {
          params: {
            dest: this.$route.params.date
          }
        },
        {
          "Content-Type": "application/json", //设置跨域头部
          // Authorization: "JWT " + sessionStorage.getItem("oemToken")
        }
      ).then(
        res => {
          res.forEach(function(item) {
            self.list.push({
              name: item.name,
              id: item.id,
              ver: item.ver,
              update_time: item.update_at.substring(0, 10),
              links: item.links,
              size: (item.size / 1024 / 1024).toFixed(2) + "M",
              description: item.description,
              classify: item.classify,
              md5: item.md5
            });
          });
          self.searchShow = true;
        },
        err => {
          //搜索页面请求失败
        }
      );
    } else {
      this.$router.replace({ name: "error" });
    }
  },
  mounted: function() {
    if (this.$route.params.id === "oem") {
      this.show_title = "镜像下载";
    } else if (this.$route.params.id === "tools") {
      this.getToolsClassifyListAction().then(() => {
        this.getShowTitleFromMenus();
      });
    } else if (this.$route.params.id === "search") {
      this.show_title = "搜索结果";
    }
  },
  computed: {
    ...mapGetters("config", {
      getToolsClassifyList: "getToolsClassifyList"
    })
  },
  data() {
    return {
      downloadIcon: "/static/img/file_download.png",
      list: [],
      tele: "", //用于存放验证的手机号
      isShow: -1, //用于控制下载地址链接
      show_title: "", //模板标题
      searchShow: false
    };
  },
  methods: {
    homeSearch: function(data) {
      let self = this;
      fetch(
        "download/search/",
        {
          params: {
            dest: data
          }
        },
        {
          "Content-Type": "application/json", //设置跨域头部
          // Authorization: "JWT " + sessionStorage.getItem("oemToken")
        }
      ).then(
        res => {
          self.list = [];
          res.forEach(function(item) {
            self.list.push({
              name: item.name,
              id: item.id,
              ver: item.ver,
              update_time: item.update_at.substring(0, 10),
              links: item.links,
              size: (item.size / 1024 / 1024).toFixed(2) + "M",
              description: item.description,
              classify: item.classify,
              md5: item.md5
            });
          });
          self.searchShow = true;
        },
        err => {}
      );
    },
    closeSearch: function() {
      let self = this;
      self.list = [];
      self.searchShow = false;
    },
    downLink: function(index) {
      this.teleInput("需要进行手机号验证", index);
    },
    getShowTitleFromMenus() {
      this.show_title = this.getToolsClassifyList.find(
        item => item.classify == this.$route.params.classify
      ).name;
    },
    ...mapActions("config", {
      getToolsClassifyListAction: "getToolsClassifyListAction"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/publics/Public.vue